import { render, staticRenderFns } from "./SupportOrganizationsPage.vue?vue&type=template&id=bf7f7834&"
import script from "./SupportOrganizationsPage.vue?vue&type=script&lang=js&"
export * from "./SupportOrganizationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports